<template>
    <div class="ebooks" style="padding-bottom: 0;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12" style="height: 100vh">
                    <iframe id="iframe-ebook" :src="ebook_link"
                            frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {getEbook} from "../../models/dashboard";
    import axios from "axios";
    import {soundClick, soundGetReward, soundClaimTreasure} from '../../utils/utils';

    export default {
        name: "Ebook",
        title: "iSMART eBook",
        data() {
            return this.initState();
        },
        created() {
            this.fetch();
        },
        mounted(){
            const iframe = document.getElementById('iframe-ebook')
            iframe.onload = function() {
                const r = iframe.contentWindow.postMessage('loadgame', '*');
            }
        },
        methods: {
            fetch(){
                this.getEbooks()
            },
            initState() {
                return {
                    ebook_link: '',
                };
            },
            async getEbooks() {
                const that = this;
                that.$store.commit("setLoading", true);
                const params = this.$route.params;
                await axios.all([
                    getEbook(params)
                ]).then(axios.spread((ebook) => {
                    that.$store.commit("setLoading", false);
                    if (ebook.data.code == 0){
                        that.ebook_link = ebook.data.results.item.content || '';
                        console.log("link_ebook: ",  that.ebook_link)
                    }
                }));
            },
        }
    }
</script>

<style scoped>
.row>*{
    padding: 0 !important;
}
</style>